import { initSelectCardSubscription } from '../components/initSelectCardSubscription';

window.addEventListener('DOMContentLoaded', handleOnLoadPage, false);

function handleOnLoadPage() {
    initSelectCardSubscription();
}
